import { AppState, UiFilterState } from '../models/app-state.model';
import { Card } from '../models/card.model';
import { Category } from '../models/category.model';
import { CardStatus, DEFAULT_CATEGORY_ID, QuickFilter, SCHEMA_VERSION } from '../constants/app.constants';

export function generateId(prefix: string): string {
  // Using native browser crypto tool as requested
  return `${prefix}-${crypto.randomUUID()}`;
}

export function createDefaultCategory(): Category {
  return {
    id: DEFAULT_CATEGORY_ID,
    name: 'Uncategorized',
    color: '#6B7280',
    isSystem: true
  };
}

export function createDefaultCard(): Card {
  const now = new Date().toISOString();
  return {
    id: generateId('card'),
    title: '',
    description: '',
    notes: '',
    categoryId: DEFAULT_CATEGORY_ID,
    status: CardStatus.IN_PROGRESS,
    showInLadder: false,
    priority: null,
    importance: null,
    parentCardId: null,
    createdAt: now,
    updatedAt: now,
    deadline: null,
    manualProgress: 0,
    ladderGroupColor: null
  };
}

export function createDefaultUiFilter(): UiFilterState {
  return {
    textQuery: '',
    status: 'ALL',
    categoryId: null,
    quickFilter: QuickFilter.ALL
  };
}

export function createDefaultAppState(): AppState {
  return {
    schemaVersion: SCHEMA_VERSION,
    savedAt: new Date().toISOString(),
    categories: [createDefaultCategory()],
    ladder: { levels: [] }, // Auto-create first level when adding first card to ladder
    cards: [],
    ui: {
      ladder: createDefaultUiFilter(),
      allCards: createDefaultUiFilter()
    }
  };
}
